import { render, staticRenderFns } from "./today-look.vue?vue&type=template&id=153335d6&scoped=true&"
import script from "./today-look.vue?vue&type=script&lang=js&"
export * from "./today-look.vue?vue&type=script&lang=js&"
import style0 from "./today-look.vue?vue&type=style&index=0&id=153335d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153335d6",
  null
  
)

export default component.exports